export default [{
    name: '陈会方',
    typeName: '散装食品'
}, {
    name: '邱双喜',
    typeName: '散装食品'
}, {
    name: '李桂芳',
    typeName: '散装食品'
}, {
    name: '雷警卫',
    typeName: '水产品'
}, {
    name: '朱年生',
    typeName: '散装食品加工'
}, {
    name: '殷德祥',
    typeName: '食品零售餐饮服务'
}, {
    name: '李典群',
    typeName: '猪肉零售'
}, {
    name: '曾强',
    typeName: '食品、水产品'
}, {
    name: '付本章',
    typeName: '粮食加工食品零售'
}, {
    name: '曾祥军',
    typeName: '散装食品现场加工'
}, {
    name: '张家学',
    typeName: '散装食品'
}, {
    name: '周升',
    typeName: '散装食品'
}, {
    name: '陶表杨',
    typeName: '肉类零售'
}, {
    name: '瞿萍',
    typeName: '散装食品'
}, {
    name: '马春华',
    typeName: '散装食品'
}, {
    name: '田书霞',
    typeName: '冷鲜食品'
}, {
    name: '张延金',
    typeName: '鲜肉冰货'
}, {
    name: '易桂芬',
    typeName: '冰货零售'
}, {
    name: '陈斌',
    typeName: '餐饮服务'
}, {
    name: '凌国玉',
    typeName: '餐饮烤鸭'
}, {
    name: '任媛',
    typeName: '食品零售'
}, {
    name: '雷金桥',
    typeName: '蔬菜'
}, {
    name: '高海华',
    typeName: '蔬菜'
}, {
    name: '杨五',
    typeName: '蔬菜'
}, {
    name: '张小华',
    typeName: '蔬菜'
}, {
    name: '黄东保',
    typeName: '蔬菜'
}, {
    name: '王汉桥',
    typeName: '蔬菜'
}, {
    name: '邵双莲',
    typeName: '蔬菜'
}, {
    name: '滕启善',
    typeName: '蔬菜'
}, {
    name: '唐想桂',
    typeName: '蔬菜'
}, {
    name: '唐任华',
    typeName: '藕类'
}, {
    name: '邵莲仙',
    typeName: '蔬菜'
}, {
    name: '罗望娥',
    typeName: '蔬菜'
}, {
    name: '罗么',
    typeName: '蔬菜'
}, {
    name: '徐晓丽',
    typeName: '水发菜'
}, {
    name: '丁海霞',
    typeName: '蔬菜'
}, {
    name: '张金林',
    typeName: '蔬菜'
}, {
    name: '姚连明',
    typeName: '蔬菜'
}, {
    name: '康勇',
    typeName: '蔬菜'
}, {
    name: '程朝阳',
    typeName: '蔬菜'
}, {
    name: '陈晓光',
    typeName: '蔬菜'
}, {
    name: '刘月斌',
    typeName: '蔬菜'
}, {
    name: '古宏顶',
    typeName: '蔬菜'
}, {
    name: '曾小冬',
    typeName: '蔬菜'
}, {
    name: '蔡国亮',
    typeName: '蔬菜'
}, {
    name: '杨敦刚',
    typeName: '蔬菜'
}, {
    name: '邹青香',
    typeName: '蔬菜'
}, {
    name: '杨昌琼',
    typeName: '蔬菜、果品'
}, {
    name: '袁长春',
    typeName: '蔬菜'
}, {
    name: '刘翠娥',
    typeName: '蔬菜'
}, {
    name: '陈翔海',
    typeName: '蔬菜'
}, {
    name: '韩双凤',
    typeName: '蔬菜'
}, {
    name: '夏赵星',
    typeName: '蔬菜'
}, {
    name: '陈年祥',
    typeName: '蔬菜、禽蛋'
}]
